import React from "react";
import LoginComponent from "../components/Entry/LoginComponent";

export default function LoginPage() {
    return (
        <div className="w-full dark:bg-dark-100 bg-stone-100">
            <div>
                <LoginComponent />
            </div>
        </div>
    );
}
